import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { ChickenTestComponent } from './chicken-test.component';
import { ChickenTestService } from './chicken-test.service';

@NgModule({
    imports: [CommonModule, MaterialModule],
    exports: [ChickenTestComponent],
    declarations: [ChickenTestComponent],
    providers: [ChickenTestService]
})
export class ChickenTestModule {}
